"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleClass = exports.scrollbarWidth = exports.scrollToTop = exports.scrollToBottom = exports.scrollTo = exports.rem = exports.getScrollBottom = exports.findScrollParent = exports.createGhostElement = exports.closest = void 0;
// NB. Element.scrollTo doesn't work in MS Edge, but scrollLeft/scrollTop do.
// Window.scrollTo still works and can be used as is.
// https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/15534521/
var isElementScrollToSupported = ('scrollTo' in Element.prototype);

// NB. If the check passes, it also means that ScrollToOptions are supported
// https://stackoverflow.com/a/51070207
var isSmoothScrollSupported = ('scrollBehavior' in document.documentElement.style);

// Cross-browser Element.closest()
// http://developer.mozilla.org/en-US/docs/Web/API/Element/closest
var closest = exports.closest = function closest(element, selector) {
  var closestElement = element;
  do {
    if (closestElement.matches(selector)) {
      return closestElement;
    }
    closestElement = closestElement.parentElement || closestElement.parentNode;
  } while (closestElement !== null && closestElement.nodeType === 1);
  return null;
};
var createGhostElement = exports.createGhostElement = function createGhostElement() {
  var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
  var element = document.createElement(tagName);
  element.style.visibility = 'hidden';
  element.style.position = 'absolute';
  element.style.top = '-9999px';
  return element;
};
var findScrollParent = exports.findScrollParent = function findScrollParent(element) {
  var overflowRegex = /auto|scroll/;
  if (!element) {
    return null;
  }
  element = element.parentElement;
  while (element && element.nodeType === 1) {
    var computedStyle = window.getComputedStyle(element);
    if (overflowRegex.test(computedStyle.overflow)) {
      return element;
    }
    element = element.parentElement || element.parentNode;
  }
  return null;
};
var getScrollBottom = exports.getScrollBottom = function getScrollBottom(element) {
  if (element === window) {
    return document.documentElement.scrollHeight - window.pageYOffset - Math.round(window.innerHeight);
  }
  return element.scrollHeight - element.scrollTop - Math.round(element.clientHeight);
};
var rem = exports.rem = function rem(value) {
  var rootStyle = window.getComputedStyle(document.body);
  var baseFontSize = parseFloat(rootStyle.getPropertyValue('font-size'));
  return value * baseFontSize;
};

/**
 * Based on:
 * https://davidwalsh.name/detect-scrollbar-width
 */
var scrollbarWidth = exports.scrollbarWidth = function () {
  var ghost = createGhostElement();
  ghost.style.height = '100px';
  ghost.style.overflow = 'scroll';
  ghost.style.width = '100px';
  document.body.appendChild(ghost);
  var value = ghost.offsetWidth - ghost.clientWidth;
  document.body.removeChild(ghost);
  return value;
}();
var scrollTo = exports.scrollTo = function scrollTo(element, options) {
  if (isElementScrollToSupported && isSmoothScrollSupported) {
    element.scrollTo(options);
  } else {
    element.scrollLeft = options.left;
    element.scrollTop = options.top;
  }
};
var scrollToBottom = exports.scrollToBottom = function scrollToBottom(element) {
  var behavior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
  scrollTo(element, {
    behavior: behavior,
    left: element.scrollLeft,
    top: element.scrollHeight
  });
};
var scrollToTop = exports.scrollToTop = function scrollToTop(element) {
  var behavior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
  scrollTo(element, {
    behavior: behavior,
    left: element.scrollLeft,
    top: 0
  });
};

/**
 * This helper method is here because Internet Explorer does not
 * support the second argument to Element.classList.toggle.
 */
var toggleClass = exports.toggleClass = function toggleClass(element, className, value) {
  if (value) {
    element.classList.add(className);
  } else {
    element.classList.remove(className);
  }
};
//# sourceMappingURL=dom-utils.js.map